(function () {
  'use strict';

  function initPopup(popup) {
    var sectionId = popup.getAttribute('data-section-id');
    var storageMode = popup.getAttribute('data-storage-mode') || 'session';
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    var storageKey = 'announcement-popup-dismissed-' + sectionId;
    var dialog = popup.querySelector('.announcement-popup__dialog');
    var closeEls = popup.querySelectorAll('[data-announcement-popup-close]');
    var lastFocused = null;

    function getStore() {
      if (storageMode === 'forever') return window.localStorage;
      if (storageMode === 'session') return window.sessionStorage;
      return null; // 'always' — no persistence
    }

    function isDismissed() {
      var store = getStore();
      if (!store) return false;
      try {
        return store.getItem(storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    function markDismissed() {
      var store = getStore();
      if (!store) return;
      try {
        store.setItem(storageKey, '1');
      } catch (e) {
        /* storage unavailable — ignore */
      }
    }

    function openPopup() {
      lastFocused = document.activeElement;
      popup.style.display = 'flex';
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // allow display change to apply before transitioning in
      requestAnimationFrame(function () {
        popup.classList.add('is-open', 'is-visible');
        if (dialog) dialog.focus();
      });
      document.addEventListener('keydown', onKeydown);
    }

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      markDismissed();
      window.setTimeout(function () {
        popup.classList.remove('is-open');
      }, 250);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closePopup();
      }
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.tagName === 'A' && el.getAttribute('href') && el.getAttribute('href') !== '#') {
          // let the link navigate; still record dismissal
          markDismissed();
          return;
        }
        e.preventDefault();
        closePopup();
      });
    });

    if (!isDismissed()) {
      window.setTimeout(openPopup, delay);
    }
  }

  function init() {
    var popups = document.querySelectorAll('[data-announcement-popup]');
    popups.forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the section is added/updated in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var popup = event.target.querySelector('[data-announcement-popup]');
    if (popup) initPopup(popup);
  });
})();
